import {Component, OnInit} from '@angular/core';
import {CloseButtonData} from '@/controls/close-button/close-button-data';
import {GlobalsService} from '@/_services/globals.service';
import {CloseButtonComponent} from '@/controls/close-button/close-button.component';
import {CdkDrag, CdkDragHandle} from '@angular/cdk/drag-drop';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatCheckbox} from '@angular/material/checkbox';

@Component({
  selector: 'app-dsgvo',
  templateUrl: './dsgvo.component.html',
  styleUrls: ['./dsgvo.component.scss'],
  imports: [
    CloseButtonComponent,
    CdkDragHandle,
    CdkDrag,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatCheckbox
  ]
})
export class DsgvoComponent implements OnInit {

  closeData: CloseButtonData = {
    colorKey: 'legal'
  };

  constructor(public globals: GlobalsService) {
  }

  ngOnInit(): void {
  }

}
